import React, { useState, useEffect } from "react";
import { auth } from "./firebase";
import logo from "./logo.svg";
import "./App.css";
import { app, analytics } from "./firebase";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import {
  Routes,
  RouterProvider,
  Route,
  Link,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
  createBrowserRouter
} from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import NewApplicant from "./pages/NewApplicant";

const router = createBrowserRouter([
  { path: "/", element: <Login /> },
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/newapp", element: <NewApplicant /> }
]);

export default function App() {
  const [user, loading, error] = useAuthState(auth);

  useEffect(() => {
    if (loading) {
      return;
    }
    if (user) {
      router.navigate("/dashboard");
    } else {
      router.navigate("/");
    }
  }, [user, loading]);

  return (
    <div className="page">
      <RouterProvider router={router} />
    </div>
  );
}
